import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useSetSubjectLine = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (payload: { id: string; subjectLineId: string; subjectLineLabel: string }) =>
      dispatch({
        type: 'SET_SELECTED_SUBJECT_LINE',
        payload,
      }),
    [dispatch],
  );
};
